module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.13613/images/background_stars.svg"